var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-20922 -14833)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 40,
    height: 40,
    transform: "translate(20922 14833)",
    fill: "#0090f0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(20926 14837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4835",
    "data-name": "Path 4835",
    d: "M16.054,15.164a1.581,1.581,0,0,1-1.467-1.571,1.5,1.5,0,0,1,2.563-1.085,1.767,1.767,0,0,1,.341.5,1.037,1.037,0,0,0,1.932-.734,3.71,3.71,0,0,0-.816-1.23,3.6,3.6,0,0,0-1.457-.868V8.953a1.033,1.033,0,1,0-2.067,0v1.188A3.379,3.379,0,0,0,12.871,12a3.658,3.658,0,0,0,3.245,5.229A1.55,1.55,0,0,1,17.635,18.8a1.519,1.519,0,0,1-1.519,1.519,1.5,1.5,0,0,1-1.405-.951,1.042,1.042,0,0,0-1.932.775,3.617,3.617,0,0,0,2.3,2.067v1.157a1.033,1.033,0,0,0,2.067,0V22.221a3.617,3.617,0,0,0,2.532-3.947,3.772,3.772,0,0,0-3.627-3.11Z",
    transform: "translate(0.384 0.231)",
    fill: "#ffc051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4836",
    "data-name": "Path 4836",
    d: "M16.5,1A15.5,15.5,0,1,0,32,16.5,15.5,15.5,0,0,0,16.5,1Zm0,28.933A13.433,13.433,0,1,1,29.933,16.5,13.433,13.433,0,0,1,16.5,29.933Z",
    transform: "translate(0 0)",
    fill: "#ffc051"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.c906e566255527fa43f83dc0dff22b31.svg";
export { ForwardRef as ReactComponent };